import { commonSlices } from "../../commons/store/registered-slices";

import mobileSlice from "./slices/mobile";

/**
 * All slices of the mobile store. The store builds its reducer map and the unhandled action
 * middleware from this object, so an action is only "known" if its slice is really registered.
 */
export const mobileSlices = {
  ...commonSlices,
  mobile: mobileSlice
};
